module.exports = __webpack_public_path__ + "img/60.58165059.png";